import I18n from 'i18n'
import { takeLatest, call, put } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import editExternalCourse from 'api/administration/externalCourses/Edit'
import { ExternalCourseModel } from 'models/externalCourse.model'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../actions/externalCourses.action'

async function handleEditExternalCourse(
  externalCourse: ExternalCourseModel,
  externalCourseId: string
) {
  return await editExternalCourse(externalCourse, externalCourseId)
}

function* editExternalCourseEffectSaga(action: any) {
  try {
    yield call(
      handleEditExternalCourse,
      action.payload.externalCourse,
      action.payload.externalCourseId
    )
    if (action.payload.onlySave) {
      yield put(push('/administration/external_courses/'))
    } else {
      yield put(
        fromActions.Actions.getAdminExternalCourse(
          action.payload.externalCourseId
        )
      )
      yield put(
        push(
          `/administration/external_courses/${action.payload.externalCourseId}/lessons/`
        )
      )
    }
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editExternalCourseWatcherSaga() {
  yield takeLatest(
    fromActions.EDIT_EXTERNAL_COURSE,
    editExternalCourseEffectSaga
  )
}
